import { Injectable } from '@angular/core';

@Injectable()
export class NonceService {
  public generate(): string {
    const r = () => Math.random().toString(36).substr(2);
    return `${r()}${r()}_${window.location.host}`;
  }
}
